import { createComponent } from '@carvana/merch-components';

export const TermsCardContainer = createComponent('div', {
  className:
    'flex max-w-[640px] flex-col items-center justify-center gap-xl rounded-xl bg-background-default p-xl shadow sm:gap-2xl sm:p-4xl'
});

export const TermsContent = createComponent('div', {
  className:
    'grid grid-cols-3 grid-rows-[2fr_1fr] items-center gap-xl [grid-template-areas:"timer_copy_copy""cta_cta_cta"] sm:grid-rows-2 sm:gap-x-3xl sm:gap-y-xl sm:px-6xl sm:[grid-template-areas:"timer_copy_copy""timer_cta_cta"]'
});

export const TermsContentHeader = createComponent('div', {
  className: 'gap-xl [grid-area:timer]'
});

export const TermsProgress = createComponent('div', {
  className: 'text-text-strong t-body-sm sm:t-body-md'
});

export const TermsProgressHeading = createComponent('p', {
  className: 'text-text-strong t-heading-xl sm:t-heading-3xl'
});

export const TermsContentCopy = createComponent('div', {
  className:
    'gap-md text-left text-text-strong t-body-sm [grid-area:copy] sm:text-start sm:t-body-md'
});

export const TermsCta = createComponent('div', {
  className: 'self-stretch [grid-area:cta] sm:self-auto'
});

export const CosignerContent = createComponent('div', {
  className:
    'flex w-full flex-col gap-xl sm:flex-row sm:items-center sm:justify-between'
});

export const HorizontalRule = createComponent('hr', {
  className: 'w-full rounded-none border-t border-border-subtle'
});
